@if (readonly) {
    <div>
        {{ answer ? answer : ('formEntryOptions.noSelection' | t) }}
    </div>
} @else {
    <div>
        @switch (field.FieldType) {
            @case (types.Radio) {
                <div class="radio-options">
                    @for (
                        option of optionSettings.options;
                        track option;
                        let optionIndex = $index
                    ) {
                        <div class="form-check">
                            <input
                                type="radio"
                                class="form-check-input"
                                id="radio-{{ field.ID }}-{{ optionIndex }}"
                                name="radio-{{ field.ID }}"
                                (click)="updateRadio(option)"
                                [checked]="singleSelected === option"
                            />
                            <label
                                class="form-check-label"
                                for="radio-{{ field.ID }}-{{ optionIndex }}"
                                >{{ option }}</label
                            >
                        </div>
                    }
                </div>
            }
            @case (types.Checkbox) {
                <div class="checkbox-options">
                    @for (
                        option of optionSettings.options;
                        track option;
                        let optionIndex = $index
                    ) {
                        <div class="form-check">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="checkbox-{{ field.ID }}-{{ optionIndex }}"
                                (click)="updateCheckbox(option)"
                                [checked]="multiSelected.indexOf(option) >= 0"
                            />
                            <label
                                class="form-check-label"
                                for="checkbox-{{ field.ID }}-{{ optionIndex }}"
                                >{{ option }}</label
                            >
                        </div>
                    }
                </div>
            }
            @case (types.Dropdown) {
                <div class="dropdown-options">
                    <ng-select
                        id="dropdown-{{ field.ID }}"
                        name="subjectSelect"
                        [ngModel]="singleSelected || multiSelected"
                        (ngModelChange)="singleSelected || (multiSelected = $event)"
                        [items]="optionSettings.options"
                        (change)="updateDropdown($event)"
                        [multiple]="optionSettings.multiSelect"
                        [closeOnSelect]="
                            !optionSettings.multiSelect ||
                            (optionSettings.multiSelect &&
                                (optionSettings.maximumSelection > 0
                                    ? optionSettings.maximumSelection
                                    : optionSettings.options.length) <=
                                    multiSelected.length + 1)
                        "
                        [maxSelectedItems]="
                            optionSettings.maximumSelection > 0
                                ? optionSettings.maximumSelection
                                : optionSettings.options.length
                        "
                    >
                    </ng-select>
                </div>
            }
        }
    </div>
}
